var _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewXpLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 65,
    viewBox: "0 0 47 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H45.8945V59C45.8945 62.0376 43.4321 64.5 40.3945 64.5H6C2.96243 64.5 0.5 62.0376 0.5 59V0.5Z",
    fill: "#DB233E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1382 54.272L24.8542 50.96C23.9216 50.0194 22.4135 50.0194 21.4908 50.96L18.2068 54.272C17.2444 55.2426 15.6768 55.2426 14.7144 54.272L13.127 52.671L18.1572 47.5978C20.9253 44.8061 25.4098 44.8061 28.1779 47.5978L33.2081 52.671L31.6206 54.272C30.6682 55.2426 29.1105 55.2426 28.1382 54.272Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3092 49.8192L8.72176 48.2182C7.75937 47.2476 7.75937 45.6666 8.72176 44.696L12.0058 41.3839C12.9384 40.4433 12.9384 38.9223 12.0058 37.9918L8.72176 34.6797C7.75937 33.7091 7.75937 32.1281 8.72176 31.1575L10.3092 29.5565L15.3394 34.6296C18.1075 37.4214 18.1075 41.9442 15.3394 44.736L10.3092 49.8192Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2168 33.8392C21.4012 33.8392 19.5856 33.1487 18.2065 31.7479L13.1763 26.6747L14.7637 25.0737C15.7261 24.1031 17.2937 24.1031 18.2561 25.0737L21.5401 28.3857C22.4628 29.3163 23.9808 29.3163 24.9035 28.3857L28.1875 25.0737C29.1499 24.1031 30.7175 24.1031 31.6799 25.0737L33.2673 26.6747L28.2371 31.7479C26.8481 33.1287 25.0325 33.8392 23.2168 33.8392Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0853 49.7792L31.0551 44.706C28.287 41.9143 28.287 37.3914 31.0551 34.5997L36.0853 29.5265L37.6727 31.1275C38.6351 32.0981 38.6351 33.6791 37.6727 34.6497L34.3887 37.9618C33.4561 38.9024 33.4561 40.4233 34.3887 41.3539L37.6727 44.666C38.6351 45.6366 38.6351 47.2176 37.6727 48.1882L36.0853 49.7792Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H45.8945V59C45.8945 62.0376 43.4321 64.5 40.3945 64.5H6C2.96243 64.5 0.5 62.0376 0.5 59V0.5Z",
    stroke: "url(#paint0_linear_75_252)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_252",
    x1: 5.49998,
    y1: 68.9647,
    x2: -0.300639,
    y2: 4.43141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3D59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB233E"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewXpLogo);
export default __webpack_public_path__ + "static/media/newXpLogo.9f188bb562bf80c5b3171d1516bcf021.svg";
export { ForwardRef as ReactComponent };